export const TIMEKEEPING_STATUSES = {
  APPROVED: 'approved',
  CONFLICT: 'conflict',
  PENDING: 'pending',
  DISPUTED: 'disputed',
  RESOLVED: 'resolved',
  FINALIZED: 'finalized',
  OVERTIME: 'overtime',
};

export const BULK_ACTION_TYPES = {
  APPROVE: 'Approve',
  RESOLVE: 'Resolve',
  FINALIZE: 'Finalize',
};

export const EXPORT_TYPES = {
  PAYROLL: 'payroll',
  BILLING: 'billing',
};

export const TIMEKEEPING_TAGS = {
  DISPUTED: 'disputed',
  MISSING_PUNCH: 'missingPunch',
  LOOKS_GOOD: 'looksGood',
  SUSPICIOUS: 'suspicious',
};

export const WEEKLY_DAILY_OPTIONS = {
  daily: {
    label: 'timekeeping.filter.dailyView',
    value: 'daily',
  },
  weekly: {
    label: 'timekeeping.filter.weeklyView',
    value: 'weekly',
  },
};
